<template>
<div class="DeviceInfo">
    <div class="panel-title width-line">
        <div class="title-text">{{$t(/*基本信息*/'device.base_info')}}</div>
    </div>
    <el-descriptions :column="3" border size="medium" class="device-descriptions" labelClassName='item-label' >
        <el-descriptions-item :span="3" labelClassName='divide-item-label' contentClassName='divide-item-content'></el-descriptions-item>

        <el-descriptions-item label="IMEI">{{detail.imei}}</el-descriptions-item>
        <el-descriptions-item label="IMSI">{{detail.imsi}}</el-descriptions-item>
        <el-descriptions-item label="ICCID">{{detail.iccid}}</el-descriptions-item>

        <el-descriptions-item :label="$t(/*协议版本*/'device.protocol_version')">{{detail.protocol_version || detail.protocolVersion}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*软件版本*/'device.software_version')">{{detail.software_version || detail.softwareVersion}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*硬件版本*/'device.hardware_version')">{{detail.hardware_version || detail.hardwareVersion}}</el-descriptions-item>

        <el-descriptions-item :span="3" labelClassName='divide-item-label' contentClassName='divide-item-content'></el-descriptions-item>

        <el-descriptions-item :label="$t(/*卫星数量*/'device.satellite_count')">{{detail.satellite_count || detail.satelliteCount}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*速度*/'device.speed')">{{detail.speed}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*导航*/'device.navigate')">{{detail.navigate}}</el-descriptions-item>

        <el-descriptions-item :label="'GSM ' + $t(/*信号强度*/'device.signal_strength')">{{detail.gsm_signal_strength || detail.gsmSignalStrength}}</el-descriptions-item>
        <el-descriptions-item :label="'GPS ' + $t(/*卫星数量*/'device.satellite_count')">{{detail.gps_satellite_count || detail.gpsSatelliteSount}}</el-descriptions-item>
        <el-descriptions-item :label="'GPS ' + $t(/*信号强度*/'device.signal_strength')">{{detail.gps_signal_strength || detail.gpsSignalStrength}}</el-descriptions-item>

        <el-descriptions-item :label="$t(/*经纬度*/'c.coordinate')">{{detail.latitude}}, {{detail.longitude}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*上次GPS上报时间*/'device.last_gps_report_time')" :span="2">{{$U.timeFormat(detail.last_gps_report_time || detail.lastGpsReportTime)}}</el-descriptions-item>

        <el-descriptions-item :span="3" labelClassName='divide-item-label' contentClassName='divide-item-content'></el-descriptions-item>

        <el-descriptions-item :label="$t(/*当前里程数*/'device.mileage_curr')">{{detail.mileage}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*总里程*/'device.mileage_total')">{{detail.mileage_total || detail.mileageTotal}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*里程耐力*/'device.mileage_endurance')">{{detail.mileage_endurance || detail.mileageEndurance}}</el-descriptions-item>

        <el-descriptions-item :label="$t(/*电池电量*/'device.battery_power')">{{detail.battery}}%</el-descriptions-item>
        <el-descriptions-item :label="$t(/*锁定状态*/'device.lock_status')">{{detail.lock_status || detail.lockStatus}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*启动状态*/'device.boot_status')">{{detail.boot_status || detail.bootStatus}}</el-descriptions-item>

        <el-descriptions-item :label="$t(/*车载电脑电池*/'device.ecu_battery')">{{detail.ecu_battery || detail.ecuBattery}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*车载电脑GPS状态*/'device.ecu_gps_status')">{{detail.ecu_gps_status || detail.ecuGpsStatus}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*上次上报时间*/'device.last_status_report_time')">{{$U.timeFormat(detail.last_status_report_time || detail.lastStatusReportTime)}}</el-descriptions-item>
    </el-descriptions>
</div>
</template>

<script>
export default {
    components: {},
    props: {
        uid: { type: [String] },
        id:  { type: [String, Number] },
        space: { type: [String, Number] },
        detail: { type: Object, default: () => {}},
    },
    data() {
        return {
        }
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>

<style lang='scss'>
.DeviceInfo {
    .device-descriptions {
        .item-label {
            max-width: 240px;
        }
        .divide-item-label, .divide-item-content {
            background-color: transparent;
            border: 0;
        }
    }
}
</style>